import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var PageFirstIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 14 14" }),
        React.createElement("path", { d: "M13.175 11.2142L8.97167 7L13.1858 2.78583C13.6083 2.36333 13.6083 1.68083 13.1858 1.25833C12.7633 0.835833 12.0808 0.835833 11.6583 1.25833L6.68583 6.23083C6.26333 6.65333 6.26333 7.33583 6.68583 7.75833L11.6583 12.7308C12.0808 13.1533 12.7633 13.1533 13.1858 12.7308C13.5975 12.3192 13.5975 11.6258 13.175 11.2142ZM1.58333 0.5C2.17917 0.5 2.66667 0.9875 2.66667 1.58333V12.4167C2.66667 13.0125 2.17917 13.5 1.58333 13.5C0.9875 13.5 0.5 13.0125 0.5 12.4167V1.58333C0.5 0.9875 0.9875 0.5 1.58333 0.5Z" })));
};

export { PageFirstIcon };
//# sourceMappingURL=PageFirstIcon.esm.js.map
